import React from 'react';
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { useFormikContext } from 'formik';

import { PRIVACY_AND_GDPR_URL, TERMS_AND_CONDITIONS_URL } from '@config/const';

export const CheckoutTermsAndConditions = () => {
  const { values, handleChange, errors, touched } = useFormikContext();
  return (
    <Form.Check
      type="checkbox"
      name="termsAndConditions"
      size="sm"
      onChange={handleChange}
      value={values.termsAndConditions}
      className="mb-2"
      isValid={touched.termsAndConditions && !errors.termsAndConditions}
      isInvalid={touched.termsAndConditions && errors.termsAndConditions}
      label={
        <>
          I accept{' '}
          <Link to={TERMS_AND_CONDITIONS_URL} target="_blank">
            General Terms and Conditions
          </Link>{' '}
          |{' '}
          <Link to={PRIVACY_AND_GDPR_URL} target="_blank">
            Privacy & GDPR Policy
          </Link>
          .
        </>
      }
      feedback={errors.termsAndConditions}
      feedbackType="invalid"
    />
  );
};
